import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A season for catching colds",
  "description": "",
  "published": "2009-09-06T00:00:00.000Z",
  "redirect_from": ["/blog/a-season-for-catching-colds/swizec/716"],
  "categories": "life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/33363480@N05/3890583845/"
          }}><img parentName="a" {...{
              "src": "https://farm4.static.flickr.com/3492/3890583845_0a699a5330_m.jpg",
              "alt": "21,500 kms to go .. the start of the Trans Can...",
              "title": "21,500 kms to go .. the start of the Trans Can..."
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/33363480@N05/3890583845/"
          }}>{`zedzap`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Yes, you know the time. That time when no matter what you do your nose will be slightly runny, you will start sneezing for unknown reasons and the bed just seems all too warm in the morning. That time is here!`}</p>
    <p>{`A week ago it looked like autumn was already upon us, but then she decided to go hide in the woods for a little bit again and we had horrible heat over the day ... while it was still barely above 10C at night. Evil. But now, after the Autumn Rains, as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Stephen_King",
        "title": "Stephen King"
      }}>{`Stephen King`}</a>{` tends to call them in The Dark Tower, it seems we've finally arrived. Arrived at that wonderful time of the year when summer is finally over.`}</p>
    <p>{`But why am I writing a stupid blogpost about weather you might ask, what manner of madnes is this when the most inquisitive of minds, the most wondrous of souls and an all around strapping good lad starts writing something so uninspired, so boring and mundane, that it might be about weather?`}</p>
    <p>{`Well the answer is this: I find weather to be incredibly fascinating and worthy of discussion, especially when summer is starting and ending simply because I loathe summer with all the passion even a midget penguin could not contain. Nope, not even him.`}</p>
    <p>{`Also I'm going to London next week and I needed practice on talking about weather.`}</p>
    <p>{`PS: dear Zemanta, I said Dark Tower, not Dark Tower VII, stop being too specific with your links `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Damnation",
        "title": "Damnation"
      }}>{`damn it!`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/6fa79d83-1e02-4bde-8b5a-dfe7fe6a2c3b/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=6fa79d83-1e02-4bde-8b5a-dfe7fe6a2c3b",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      